export default "__VITE_ASSET__94e3659e__"